import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const {
    apiKey,
    apiSecret,
} = constantsData.forms.apiKeys.create;

const {
    apiKey: apiKeyName,
    apiSecret: apiSecretName,
} = formFieldNamesData;

export const organizationApiKeyFormData = [
    {
        isDisabled: true,
        isOptional: true,
        label: apiKey.label,
        name: apiKeyName,
        type: InputTypeEnum.TEXT,
    },
    {
        isDisabled: true,
        isOptional: true,
        label: apiSecret.label,
        name: apiSecretName,
        type: InputTypeEnum.TEXT,
    },
];
